import companyProfileActionConstants from '../constants/companyProfileActionConstants';

const initialState = {
  companyProfile: null,
  companyProfileLoading: false,
  error: null,
};

const companyProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case companyProfileActionConstants.GET_COMPANY_PROFILE:
      return {
        ...state,
        companyProfileLoading: true,
      };
    case companyProfileActionConstants.GET_COMPANY_PROFILE_SUCCESS:
      return {
        ...state,
        companyProfile: action.payload,
        companyProfileLoading: false,
      };
    case companyProfileActionConstants.GET_COMPANY_PROFILE_ERROR:
      return {
        ...state,
        companyProfileLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default companyProfileReducer;
